import React from "react";

import { useComponentVisible } from "../../../../../../../hooks/common/useComponentVisible";

import Icon from "../../../../../../Common/DesignSystem/Icons/Icon";
import colours from "../../../../../../Common/DesignSystem/Colours";

export const VehicleMenuCell = ({ vehicle, history, match }) => {
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible({ isInitialVisible: false });

    const editVehicle = (vehicle) => {
        setIsComponentVisible(false);

        const { path } = match;
        const { id: vehicleId, V_ID: sourceVehicleId } = vehicle;

        history.push(`${path}/vehicle/${sourceVehicleId}/Edit/${vehicleId}`);
    }

    const addReminder = (vehicleId) => {
        setIsComponentVisible(false);
        
        const { path } = match;
        history.push(`${path}/vehiclereminder/${vehicleId}`);
    }

    const retireVehicle = (vehicleId) => {
        setIsComponentVisible(false);
        
        const { path } = match;
        history.push(`${path}/retire/${vehicleId}`);
    }

    return (
        <>
            <button
                className="actions-menu-btn"
                onClick={() => setIsComponentVisible(true)}
            >
                <Icon name="ExtraOptions" size={24} />
            </button>
            <div ref={ref}>
                {isComponentVisible && (
                    <div className="dropdown-actions-menu">
                        <ul>
                            <li onClick={() => editVehicle(vehicle)}>
                                <Icon name="Edit" size={24} style={{ color: colours.primary.blue }} />
                                <span>Edit</span>
                            </li>
                            {vehicle.status === 'active' && (
                                <>
                                    <li onClick={() => addReminder(vehicle.V_ID)}>
                                        <Icon name="Reminder" size={24} style={{ color: colours.primary.blue }} />
                                        <span>Add Reminder</span>
                                    </li>
                                    <li onClick={() => retireVehicle(vehicle.V_ID)}>
                                        <Icon name="RetireDate" size={24} style={{ color: colours.primary.blue }} />
                                        <span>Retire</span>
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>
                )}
            </div>
        </>
    );
};
